import Logo from "./Logo";
import Mission from "./Mission";
import Team from "./Team";
import Text from "./Text";

export default function About() {
  return (
    <>
      <Logo />
      <Text />
      <Team />
      <Mission />
    </>
  );
}
